export default {
  async mounted() {
    const channel = new BroadcastChannel('third-party-deposit')

    const {
      amount,
      third_party_account_uuid: thirdPartyAccountId,
      player_bank_account_id: playerBankAccountId
    } = this.$route.query

    if (!amount || !thirdPartyAccountId || !playerBankAccountId) {
      window.location.replace('/player/deposits')
    } else {
      const createThirdPartyDepositPayment = await this.$store.dispatch(
        'themes/deposit/createDepositThirdParty',
        this.$route.query
      )
      if (!createThirdPartyDepositPayment || createThirdPartyDepositPayment?.error) {
        await channel.postMessage({ success: false, error_code: createThirdPartyDepositPayment?.code, message: createThirdPartyDepositPayment?.message })
        window.close()
      } else {
        await channel.postMessage({ success: true })
      }
      window.location.replace(createThirdPartyDepositPayment)
    }
  }
}
